import axios from "axios";
import { isTransformationNotAllowed } from "../../util/isTranformationAllowed";
import { APIS } from "../../endpoints";
import api from "./../../services/api";

const baseUrl = `${process.env.REACT_APP_MONGODB_URL}`;

/**
 * This function return Masterlist Integrated Timeline data
 * @param {String} alias - Alias of Masterlist
 * @param {String} masterlistType - Masterlist Type
 * @returns {Promise<Object>} - Function return Integrated Timeline data
 */

export const getIntegratedTimelineData = async (alias, masterlistType) => {
    if (isTransformationNotAllowed() === true) {
        const response = await getIntegratedTimelineDummyData();
        return response;
    } else if (isTransformationNotAllowed() === false) {
        const response = await getIntegratedTimelineAPIData(alias, masterlistType);
        return response;
    }
};

export const getIntegratedTimelineDummyData = async () => {
    return [];
};

export const getIntegratedTimelineAPIData = async (alias, masterlistType) => {
    const result = await axios.get(baseUrl + masterlistType + '/' + alias + '/body-of-work/integrated-timeline');
    if (result) {
        return result?.data?.data;
    }
};


/**
 * Integrated Timeline Service Functions
 * API endpoint: admin/personality/{alias}/integratedtimeline/integratedtimeline
 */

/**
 * Get personality integrated timeline data
 * @param {string} alias - Personality alias
 * @returns {Promise<Array>} - Promise with integrated timeline data
 */
export const getPersonalityIntegratedTimelineData = async (alias) => {
    const result = await api.get(`${APIS.BASE_URL}admin/personality/${alias}/integratedtimeline/integratedtimeline`)
    if (result) {
        return result?.data?.data?.data;
    } else {
        return [];
    }
};

/**
 * Update personality integrated timeline data
 * @param {string} alias - Personality alias
 * @param {Array} data - Updated integrated timeline data
 * @returns {Promise<Object>} - Promise with the API response
 */
export const updatePersonalityIntegratedTimelineData = async (alias, data) => {
    const result = await api.put(`${APIS.BASE_URL}admin/personality/${alias}/integratedtimeline/integratedtimeline`, data)

    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

/**
 * Delete personality integrated timeline data
 * @param {string} alias - Personality alias
 * @param {Array} deletedItems - Array of items to be deleted
 * @returns {Promise<Object>} - Promise with the API response
 */
export const deletePersonalityIntegratedTimelineData = async (alias, deletedItems) => {
    const result = await api.delete(`${APIS.BASE_URL}admin/personality/${alias}/integratedtimeline/integratedtimeline`, {data: { deletedItems }})

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};